/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ImportItemViewModel } from "../types/ImportItemViewModel.ts";

export const importItemViewModelSchema = z.object({
  examLangId: z.optional(z.number().int()),
  examItemIds: z.array(z.number().int()).nullish(),
}) as unknown as ToZod<ImportItemViewModel>;
